export const ForgetPasswordTypes = {
  FORGET_PASSWORD_RESET: '[forgetPassword]FORGET_PASSWORD_RESET',
  FORGET_PASSWORD_REQUEST: '[forgetPassword]FORGET_PASSWORD_REQUEST',
  FORGET_PASSWORD_SUCCESS: '[forgetPassword]FORGET_PASSWORD_SUCCESS',
  FORGET_PASSWORD_FAILURE: '[forgetPassword]FORGET_PASSWORD_FAILURE',
};
